import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="remote-click"
export default class extends Controller {
  static targets = ["input"]

  click() {
    this.inputTarget.focus();
    this.inputTarget.click();
  }
}
